import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as Yup from "yup";

// formik components
import { Formik, Form, Field } from "formik";
import Swal from "sweetalert2";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { Box, CircularProgress, Dialog } from "@mui/material";

import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { addNewPlaceApi, updatePlaceApi } from "api/places";

function EventPlaces({ openEventPlace, closeEventPlace, refreshData, isEdite, openModalItemData, newPlaceData }) {
  const [isOnlineChecked, setIsOnlineChecked] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const validationSchema = Yup.object().shape({
    eventPlace: Yup.string().required("Saisser le nom de nouvelle lieu"),
    eventLocation: Yup.string().required("Saisser la localisation"),
  });

  useEffect(() => {
    getInitialValue()
  }, [openModalItemData, isEdite])

  const getInitialValue = () => {
    try {
      if(isEdite) {
        setIsOnlineChecked(openModalItemData?.isOnline)
      }
    }
    catch (err) {
      console.log(err);
    }
  }

  const handleAddNewEventPlace = async (value) => {
    try {
      const formValues = {
        name: value.eventPlace,
        location: value.eventLocation,
        isOnline: isOnlineChecked
      }

      const savedPlace = await addNewPlaceApi(formValues)
      Swal.fire({
        title: "Ajoutée",
        text: "",
        icon: "success"
      });

      newPlaceData(savedPlace)

      refreshData()
      closeEventPlace()
    } catch (err) {
      console.log(err)
    }
  };

  const handleUpdateEventPlace = async (value) => {
    try {
      const formValues = {
        name: value.eventPlace,
        location: value.eventLocation,
        isOnline: isOnlineChecked
      }

      await updatePlaceApi(formValues, openModalItemData._id)
      Swal.fire({
        title: "Modifiée",
        text: "",
        icon: "success"
      });

      refreshData()
      closeEventPlace();
    } catch (err) {
      console.log(err)
    }
  };

  return (
    <div>
      <Dialog open={openEventPlace} onClose={closeEventPlace} fullWidth maxWidth="sm">
        <MDBox>
          <Grid container justifyContent="center" alignItems="center" sx={{ height: "100%" }}>
            <Grid item xs={12}>
              <Formik
                initialValues={{
                  eventPlace: isEdite ? openModalItemData?.name : "",
                  eventLocation: isEdite ? openModalItemData?.location : ""
                }}
                validationSchema={validationSchema}
                onSubmit={async (values) => {
                  isEdite ? handleUpdateEventPlace(values) : handleAddNewEventPlace(values)
                }}
              >
                <Form autoComplete="off">
                  <Card sx={{ height: "100%" }}>
                    <MDBox p={3}>
                      <MDBox>
                        <MDBox mb={1.625}>
                          <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} mb={1.2}>
                              <Field name="eventPlace">
                                {({ field, meta }) => (
                                  <>
                                    <MDInput
                                      {...field}
                                      label="Lieu"
                                      size="large"
                                      fullWidth
                                      error={meta.error}
                                      success={!meta.error && meta.touched}
                                    />
                                    {meta.touched && meta.error && (
                                      <MDTypography
                                        component="div"
                                        variant="caption"
                                        color="error"
                                        fontWeight="regular"
                                      >
                                        {meta.error}
                                      </MDTypography>
                                    )}
                                  </>
                                )}
                              </Field>
                            </Grid>
                            <Grid item xs={12} sm={12} mb={1.2}>
                              <Field name="eventLocation">
                                {({ field, meta }) => (
                                  <>
                                    <MDInput
                                      {...field}
                                      label="Localisation"
                                      size="large"
                                      fullWidth
                                      error={meta.error}
                                      success={!meta.error && meta.touched}
                                    />
                                    {meta.touched && meta.error && (
                                      <MDTypography
                                        component="div"
                                        variant="caption"
                                        color="error"
                                        fontWeight="regular"
                                      >
                                        {meta.error}
                                      </MDTypography>
                                    )}
                                  </>
                                )}
                              </Field>
                            </Grid>
                            {/* <Grid item xs={12} sm={12} mb={1.2}>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={isOnlineChecked}
                                    onChange={() => setIsOnlineChecked(!isOnlineChecked)}
                                  />
                                }
                                label={isOnlineChecked ? "Online" : "Offline"}
                              />
                            </Grid> */}
                          </Grid>
                        </MDBox>
                        {isLoaded ? (
                          <Box sx={{ display: "flex" }}>
                            <CircularProgress />
                          </Box>
                        ) : (
                          <MDButton type="submit" variant="gradient" color="dark">
                             {isEdite ? "Modifier" : "Ajouter"}
                          </MDButton>
                        )}
                      </MDBox>
                    </MDBox>
                  </Card>
                </Form>
              </Formik>
            </Grid>
          </Grid>
        </MDBox>
      </Dialog>
    </div>
  );
}

EventPlaces.propTypes = {
  openEventPlace: PropTypes.bool.isRequired,
  closeEventPlace: PropTypes.func.isRequired,
};

export default EventPlaces;
